import React from "react";

export default class Confidentialite extends React.Component {

}